import { createTheme } from "@mui/material";

export const theme = createTheme({
    components: {
      MuiTooltip: {
        styleOverrides: {
          tooltip: {
            backgroundColor: '#D11422',
            borderRadius: '4px',
            opacity: 1,
            padding: '6px 12px', 
          },
          arrow: {
            color: '#D11422',
          },
        },
      },
    },
});

export const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 600,
  height: 600,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  borderRadius: "10px",
  padding:"30px"
};
